import type { SolarProjectDetails } from './perch-project-details';

export type FicoCheckConfiguration = {
  requireFicoCheck?: boolean | null;
  requireFicoCheckForDefaultProduct?: boolean | null;
  requireFicoCheckForLmiProduct?: boolean | null;
  perchSfProductId?: string | null;
  projectDetails?: SolarProjectDetails;
};

export function resolveRequireFicoCheck(
  config: FicoCheckConfiguration | undefined,
  resolvedPerchProductId?: string | null,
  resolvedPerchProductIsLmi?: boolean | null,
): boolean {
  if (!config) return false;

  const { projectDetails } = config;
  const productId = resolvedPerchProductId?.trim() || config.perchSfProductId?.trim();

  // A project can configure the same id as both its LMI and default product, so the id alone
  // cannot tell the two apart. Trust the flag recorded when the product was selected; fall back to
  // comparing ids only when the selection did not record one.
  const isLmiProduct =
    resolvedPerchProductIsLmi ??
    !!(productId && projectDetails?.lmiProductId && productId === projectDetails.lmiProductId);

  if (isLmiProduct) {
    return !!config.requireFicoCheckForLmiProduct;
  }
  if (
    productId &&
    projectDetails?.defaultProductId &&
    productId === projectDetails.defaultProductId
  ) {
    return !!config.requireFicoCheckForDefaultProduct;
  }

  return !!config.requireFicoCheck;
}
